module.exports = __webpack_public_path__ + "static/img/6.16fe841.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/6.png
// module id = 44mN
// module chunks = 0